import {
  AuthRepository,
  type IntercomJwtResponse,
  type LoginDto,
  type LoginResponseDto,
  type RegisterEmailDto,
  type RegisterPhoneDto,
  type RegisterResponseDto,
  type SignOutResponseDto,
} from '../api/auth.repository';

export const AuthService = {
  async login(credentials: LoginDto): Promise<LoginResponseDto> {
    return await AuthRepository.login(credentials);
  },

  async registerEmail(data: RegisterEmailDto): Promise<RegisterResponseDto> {
    return await AuthRepository.registerEmail(data);
  },

  async registerPhone(data: RegisterPhoneDto): Promise<RegisterResponseDto> {
    return await AuthRepository.registerPhone(data);
  },

  async signOut(): Promise<SignOutResponseDto> {
    return await AuthRepository.signOut();
  },

  async getIntercomJwt(): Promise<IntercomJwtResponse> {
    return AuthRepository.getIntercomJwt();
  },
};
